/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTheme } from 'irmlib/styles'
import { mainRoutePageWrapperPadding, mainRouteTitleHeight } from './constants'
import { formStatusSelector, formStatusError } from 'irmlib/redux'
import { Label } from 'irmlib/components/Controls'
import { useTranslation } from 'react-i18next'

const subRoutePageWrapperPadding = '20px'
const subRouteTitleHeight = '60px'
const buttonsWrapperHeight = '60px'

const MainRoutePageContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`

const MainRoutePageWrapper = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 0px ${mainRoutePageWrapperPadding} ${mainRoutePageWrapperPadding} ${mainRoutePageWrapperPadding};
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.palette.routePageBackground};
  flex-grow: 1;
`

const MainRouteTitle = styled.div`
  font-weight: ${props => props.theme.typography.fontWeightBold};
  font-size: 22px;
  height: ${mainRouteTitleHeight};
  display: flex;
  align-items: center;
  color: ${props => props.theme.palette.primary.main};
`

export const ButtonsWrapper = styled.div`
  width: 100%;
  height: ${buttonsWrapperHeight};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const MainRoutePage = props => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <MainRoutePageContainer theme={theme}>
      <MainRoutePageWrapper theme={theme}>
        <MainRouteTitle style={{ marginLeft: `${props?.createPage ? '2rem' : 0}` }} theme={theme}>
          {props.noTranslate ? props.title : t(props.title)}
        </MainRouteTitle>
        {props.children}
      </MainRoutePageWrapper>
    </MainRoutePageContainer>
  )
}

MainRoutePage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  noTranslate: PropTypes.bool,
  title: PropTypes.string,
}

const ButtonsContainer = props =>
  <ButtonsWrapper style={{ justifyContent: props.rightButtons ? 'flex-end' : 'center' }}>
    {props.children}
  </ButtonsWrapper>

ButtonsContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  rightButtons: PropTypes.bool,
}


const SubRoutePageContainer = styled.div``

const SubRoutePageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  background-color: ${props => props.theme.palette.routeSubPageBackground};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0px ${subRoutePageWrapperPadding} 0px ${subRoutePageWrapperPadding};
`

const CreatePageWrapper = styled.div`
  // margin-left: 4%;
  position: relative;
  width: 100%;
  min-height: 100%;
  background-color: ${props => props.theme.palette.routeSubPageBackground};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
`

const SubRouteTitle = styled.div`
  font-weight: ${props => props.theme.typography.fontWeightBold};
  font-size: 18px;
  height: ${subRouteTitleHeight};
  display: flex;
  align-items: center;
`

const ChildrenContainer = styled.div`
  flex-grow: 1;
  height: 100%;
`

const ValidationMessageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  font-size: 12px;
  color: ${props => props.theme.palette.error.light};
  margin-bottom: -6px;
`
const CreateJobCrumbs = styled.span`
  font-weight: 300;
  font-style: inherit;
  font-size: 16px;
  margin: 0 30px;
`


export const SubRoutePage = props => {
  const theme = useTheme()
  const { t } = useTranslation()
  const formStatus = useSelector(formStatusSelector)
  const { createPage } = props
  return (
    <>
      {createPage 
        ? <CreatePageWrapper theme={theme}> {props?.displayTitle
          ? typeof (props.title) === 'string' 
            ? (<SubRouteTitle style={{ marginLeft: '1rem' }} theme={theme}>{props.noTranslate ? props.title : t(props.title)}
              {
            props.createJobParams ? <> <CreateJobCrumbs className='createJobCrumbs'>{`${props?.createJobParams[0]}-${props?.createJobParams[3]}`}</CreateJobCrumbs> <CreateJobCrumbs className='createJobCrumbs'>{props?.createJobParams[1]}</CreateJobCrumbs> <CreateJobCrumbs className='createJobCrumbs'>{props?.createJobParams[2]}</CreateJobCrumbs> </> : null
          }</SubRouteTitle>) 
            : <SubRouteTitle theme={theme} style={{ height: props.title ? '60px' : '10px' }}>{props.title}</SubRouteTitle>
          : <></>
    }
          <ChildrenContainer>
            {props.children}
          </ChildrenContainer>
          {props.buttons && formStatus === formStatusError &&
          <ValidationMessageContainer style={{ justifyContent: props.rightButtons ? 'flex-end' : 'center' }} theme={theme}>
            <Label>
              forms.formValidationError
            </Label>
          </ValidationMessageContainer>
    }
          {props.buttons && 
          <ButtonsContainer rightButtons={props.rightButtons}>
            {props.buttons}
          </ButtonsContainer>
    }
          {props.viewRecentRecords && 
          <>
            {props.viewRecentRecords}
          </>
    }
        </CreatePageWrapper> 
        : <SubRoutePageWrapper theme={theme}>
          {props?.displayTitle
            ? typeof (props.title) === 'string' 
              ? (<SubRouteTitle theme={theme}>{props.noTranslate ? props.title : t(props.title)}
                {
        props.createJobParams ? <> <CreateJobCrumbs className='createJobCrumbs'>{`${props?.createJobParams[0]}-${props?.createJobParams[3]}`}</CreateJobCrumbs> <CreateJobCrumbs className='createJobCrumbs'>{props?.createJobParams[1]}</CreateJobCrumbs> <CreateJobCrumbs className='createJobCrumbs'>{props?.createJobParams[2]}</CreateJobCrumbs> </> : null
      }</SubRouteTitle>) 
              : <SubRouteTitle theme={theme} style={{ height: props.title ? '60px' : '10px' }}>{props.title}</SubRouteTitle>
            : <></>
  }
          <ChildrenContainer>
            {props.children}
          </ChildrenContainer>
          {props.buttons && formStatus === formStatusError &&
          <ValidationMessageContainer style={{ justifyContent: props.rightButtons ? 'flex-end' : 'center' }} theme={theme}>
            <Label>
              forms.formValidationError
            </Label>
          </ValidationMessageContainer>
  }
          {props.buttons && 
          <ButtonsContainer rightButtons={props.rightButtons}>
            {props.buttons}
          </ButtonsContainer>
  }
          {props.viewRecentRecords && 
          <>
            {props.viewRecentRecords}
          </>
  }
        </SubRoutePageWrapper> }
    </>
   
  )
}

SubRoutePage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  noTranslate: PropTypes.bool,
  title: PropTypes.any,
  buttons: PropTypes.node,
  viewRecentRecords: PropTypes.any,
  // Align the buttons to the right. The default is to center them.
  rightButtons: PropTypes.bool,
  // Flag to display page tile - Default is true
  displayTitle: PropTypes.bool,
  createJobParams: PropTypes.any
}

SubRoutePage.defaultProps = {
  displayTitle: true
}

export const MainRouteSubRoutePage = props => {
  const { buttons, viewRecentRecords, rightButtons, noTranslate, mainTitle, subTitle, createJobParams, displayTitle = true, createPage } = props
  return (
    <MainRoutePage title={mainTitle} noTranslate={noTranslate} buttons={buttons} displayTitle={displayTitle}>
      <SubRoutePageContainer id='SubRoutePageContainer'>
        <SubRoutePage 
          buttons={buttons} 
          viewRecentRecords={viewRecentRecords} 
          rightButtons={rightButtons} 
          title={subTitle} 
          noTranslate={noTranslate} 
          displayTitle={displayTitle} 
          createJobParams={createJobParams} 
          createPage={createPage}
        >
          {props.children}
        </SubRoutePage>
      </SubRoutePageContainer>
    </MainRoutePage>
  )
}

MainRouteSubRoutePage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  noTranslate: PropTypes.bool,
  mainTitle: PropTypes.any,
  subTitle: PropTypes.any,
  buttons: PropTypes.node,
  viewRecentRecords: PropTypes.any,
  createJobParams: PropTypes.any,
  createPage: PropTypes.bool,
  // Align the buttons to the right. The default is to center them.
  rightButtons: PropTypes.bool,
  displayTitle: PropTypes.bool
}
